export default () => {
    const formSections = document.querySelectorAll('.symptomsTest__form__section');

    if (formSections) {
        formSections.forEach(section => {
            const radioGroups = section.querySelectorAll('.symptomsTest__radio');
    
            radioGroups.forEach(radioGroup => {
                const radioButtons = radioGroup.querySelectorAll('input[type="radio"]');
                const answerWrap = radioGroup.querySelector('.symptomsTest__answerWrap');
                const editButton = answerWrap.querySelector('.symptomsTest__answer__edit');
                const answerText = answerWrap.querySelector('.symptomsTest__answer--option');
                const fieldSet= radioGroup.querySelector('.symptomsTest__form__fieldset');
    
                radioButtons.forEach(radio => {
                    radio.addEventListener('change', function() {
                        const label = radioGroup.querySelector(`label[for="${radio.id}"]`);
                        
                        if (label) {
                            fieldSet.style.display = 'none';
                            answerWrap.style.display = 'flex';
    
                            answerText.textContent = label.textContent;
    
                            if (radio.value === 'No') { 
                                answerText.classList.remove('symptomsTest__answer--positive');
                                answerText.classList.add('symptomsTest__answer--negative');
                            } else {
                                answerText.classList.remove('symptomsTest__answer--negative');
                                answerText.classList.add('symptomsTest__answer--positive');
                            }
                        }
                    });
                });
    
                editButton.addEventListener('click', function() {
                    fieldSet.style.display = 'block';
                    answerWrap.style.display = 'none';
                });
            });
        });
    }
}
